import React from 'react';
import { PUBLIC_STATUS } from './services/tenderAnnouncementService';
import { EMPTY_VALUE } from './formatters';
import { usePublicLanguage } from './i18n/LanguageContext';

// Kelas *-subtle adalah utilitas bawaan tema — tidak membuat kelas warna sendiri
// supaya mode gelap ikut benar tanpa penanganan tambahan.
const STATUS_CLASS = {
  [PUBLIC_STATUS.BIDDING_OPEN]: 'bg-success-subtle text-success',
  [PUBLIC_STATUS.BIDDING_CLOSED]: 'bg-danger-subtle text-danger',
  [PUBLIC_STATUS.ANNOUNCED]: 'bg-secondary-subtle text-secondary',
};

const TenderStatusBadge = ({ status, className = '' }) => {
  const { t } = usePublicLanguage();

  const known = STATUS_CLASS[status];
  // Nilai status tetap dalam bahasa Inggris (kode dari backend); hanya labelnya
  // yang diterjemahkan.
  const label = known ? t(`status.${status}`) : EMPTY_VALUE;
  const variant = known || 'bg-light text-muted';

  return (
    <span className={`badge ${variant} public-tender__status ${className}`}>
      {label}
    </span>
  );
};

export default TenderStatusBadge;
